// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4daa0a06","239":"905ba2ce","453":"64f6b3c2","455":"6a036e85"}[chunkId] + ".chunk.js";
};